import React, { useState } from "react";
import { useNavigate, Route, Routes } from "react-router-dom";
import IncidentIntegrationForm from "../components/baseComponent/IncidentIntegrationForm";
import IncidentIntegrationTable from "../components/baseComponent/IncidentIntegrationTable";

const IncidentIntegration = () => {
  const navigate = useNavigate();
  const [isModelBoxOpen, setIsModelBoxOpen] = useState(false);

  const handleModelBoxClick = () => {
    setIsModelBoxOpen(true);
    navigate("/admin/incidentintegrationform");
  };

  const handleCloseModal = () => {
    setIsModelBoxOpen(false);
    navigate("/admin/incidentintegration"); 
  };

  return (
    <div className="main-inner-wrapper leavemenu-wrapper">
      <h1 className="incident-report-heading">Incident Integration</h1>
      <div className="px-4">
        <div className="leave-apply__wrapper p-4 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-gray-500 rounded-xl">
          <div className="flex justify-end items-center gap-4">
            <button
              className="py-2 px-3 addIncidentDetailsBtn text-white text-xs font-semibold rounded-md shadow focus:outline-none"
              onClick={handleModelBoxClick}
            >
              Add Incident Details
            </button>
          </div>
          <IncidentIntegrationTable />
        </div>
      </div>
      {isModelBoxOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <button className="modal-close" onClick={handleCloseModal}>
              Close
            </button>
            <IncidentIntegrationForm onSubmit={handleCloseModal} />
          </div>
        </div>
      )}
    </div>
  );
};

export default IncidentIntegration;
